import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const methodLibraryService = createApi({
    reducerPath: 'methodLibraryService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['MethodLibrary'],
    endpoints: (builder) => ({
        getAllMethodLibrary: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.methodLibraryController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveMethodLibrary: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.methodLibraryController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateMethodLibrary: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.methodLibraryController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteMethodLibrary: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.methodLibraryController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        getMethodLibraryById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.methodLibraryController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllMethodLibrary: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.methodLibraryController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadMethodLibrary: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.methodLibraryController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllMethodLibraryMutation,
    useSaveMethodLibraryMutation,
    useUpdateMethodLibraryMutation,
    useDeleteMethodLibraryMutation,
    useGetMethodLibraryByIdMutation,
    useFindAllMethodLibraryMutation,
    useBulkUploadMethodLibraryMutation,
} = methodLibraryService;
